/**
 * Represents how an external task source will be displayed
 */ export var ExternalTaskSourceDisplayType = /*#__PURE__*/ function(ExternalTaskSourceDisplayType) {
    ExternalTaskSourceDisplayType["None"] = "none";
    ExternalTaskSourceDisplayType["Default"] = "default";
    return ExternalTaskSourceDisplayType;
}({});
